import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_DURATION,
  coursePauseRequestedRequestUpdateModalSelector,
  setCoursePauseRequestedDuration,
  setCoursePauseRequestedStreakEnabled,
} from 'features/courseResume';
import CancelRequestButton from './CancelRequestButton';
import UpdateRequestButton from './UpdateRequestButton';
import Select from 'components/Select';
import Switch from 'components/Switch';
import styles from './CoursePauseRequestedRequestUpdateModalStages.module.scss';

function UpdateStage() {
  const dispatch = useDispatch();

  const { coursePauseRequestedDuration, coursePauseRequestedStreakEnabled } =
    useSelector(coursePauseRequestedRequestUpdateModalSelector);

  const handleDurationChange = useCallback(
    (duration) => {
      dispatch(setCoursePauseRequestedDuration(duration));
    },
    [dispatch]
  );

  const handleOnChange = useCallback(
    (event) => {
      dispatch(setCoursePauseRequestedStreakEnabled(event.target.checked));
    },
    [dispatch]
  );

  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  return (
    <div className={styles.root}>
      <div className="dark bold">
        Please update the following data to pause learner
      </div>
      <div className="p-v-20">
        <div className="m-b-10">Pause Duration</div>
        <Select
          styles={_styles}
          options={COURSE_PAUSE_REQUEST_DURATION}
          value={coursePauseRequestedDuration}
          onChange={handleDurationChange}
          menuPlacement="auto"
        />
      </div>
      <div className="p-v-20 row flex-ac">
        <div>Streak Enabled</div>
        <Switch
          checked={Boolean(coursePauseRequestedStreakEnabled)}
          onChange={handleOnChange}
          className="m-l-20"
          small
        />
      </div>
      <div className={styles.footer}>
        <CancelRequestButton />
        <UpdateRequestButton />
      </div>
    </div>
  );
}

export default UpdateStage;
